<template>
    <div :id="name"></div>
</template>

<script>
    export default {
        props: ['name', 'center', 'zoom', 'location'],
        mounted: function () {
            var vm = this;
            ymaps.ready(function () {
            var settings = {
                marker: {
                    path: "/images/marker.png",
                    size: [30, 37],
                    offset: [-15, -37]
                },
                center: vm.location.split(','),
                zoom: vm.zoom
            },
            myMap = new ymaps.Map(vm.name, 
            {
                center: settings.center,
                zoom: settings.zoom,
                controls: ['zoomControl', 'fullscreenControl']
            },
            {
                searchControlProvider: 'yandex#search'
            });
            myMap.behaviors.disable('scrollZoom');
            myMap.geoObjects
                .add(new ymaps.Placemark(vm.location.split(','), {}, {
                    // Опции.
                    // Необходимо указать данный тип макета.
                    iconLayout: 'default#imageWithContent',
                    // Своё изображение иконки метки.
                    iconImageHref: settings.marker.path,
                    // Размеры метки.
                    iconImageSize: settings.marker.size,
                    // Смещение левого верхнего угла иконки относительно
                    // её "ножки" (точки привязки).
                    iconImageOffset: settings.marker.offset
                }));
            });
        }
    }
</script>